// src/pages/EmailConfirmed.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './LandingPage.css';
import './Login.css';

export default function EmailConfirmed() {
  const navigate = useNavigate();
  const status = 'success'; // auth removed — always show the confirmed state
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    // Auth temporarily removed — just count down and redirect to the dashboard.
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/dashboard');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="container">
      <div className="background-overlay"></div>

      {/* Navbar */}
      <div className="navbar">
        <div className="logo-container">
          <Link to="/">
            <img src="/ob_logo_small_white.png" alt="OffsetBridge logo" className="logo-img" />
          </Link>
          <Link to="/" className="logo-text">OffsetBridge</Link>
        </div>
        <div className="nav-buttons">
          <button className="howItWorks-btn" onClick={() => navigate("/how-it-works")}>
            How It Works
          </button>
          <button className="login-btn" onClick={() => navigate("/login")}>
            Log In
          </button>
        </div>
      </div>

      {/* Confirmation message */}
      <div className="hero">
        <img src="/logo.png" alt="OffsetBridge" className="hero-logo" />

        {status === 'verifying' && (
          <>
            <h1 className="hero-title" style={{ fontSize: '48px', marginBottom: '16px' }}>
              Verifying...
            </h1>
            <p className="hero-subtitle">
              Please wait while we verify your email.
            </p>
          </>
        )}

        {status === 'success' && (
          <>
            <h1 className="hero-title" style={{ fontSize: '48px', marginBottom: '16px' }}>
              Email Verified!
            </h1>
            <p className="hero-subtitle" style={{ marginBottom: '24px' }}>
              Your email has been successfully verified.
            </p>
            <div className="login-form" style={{ textAlign: 'center' }}>
              <p className="login-success">
                Redirecting to dashboard in {countdown} seconds...
              </p>
              <button
                className="hero-cta"
                onClick={() => navigate('/dashboard')}
                style={{ marginTop: '20px' }}
              >
                Go to Dashboard Now
              </button>
            </div>
          </>
        )}

        {status === 'error' && (
          <>
            <h1 className="hero-title" style={{ fontSize: '48px', marginBottom: '16px' }}>
              Verification Failed
            </h1>
            <p className="hero-subtitle" style={{ marginBottom: '24px' }}>
              We couldn't verify your email. The link may have expired.
            </p>
            <div className="login-form" style={{ textAlign: 'center' }}>
              <p className="login-error">
                Please try signing up again or contact support.
              </p>
              <button
                className="hero-cta"
                onClick={() => navigate('/signup')}
                style={{ marginTop: '20px' }}
              >
                Back to Sign Up
              </button>
            </div>
          </>
        )}
      </div>

      {/* Footer */}
      <div className="footer">
        © 2025 OffsetBridge
        <Link to="/privacy-policy" className="privacy-link">
          Privacy Policy
        </Link>
        <Link to="/terms-and-conditions" className="terms-link">
          Terms & Conditions
        </Link>
      </div>
    </div>
  );
}
